import { zodMoment } from '@qapline/helpers';
import { z } from 'zod';

export const commissionExpectedLiabilitySchema = z.object({
    commissionExpectedLiability_id: z.number(),
    commission_id: z.number(),
    amount: z.coerce.number(),
    currency: z.string(),
    currencyExchangeRate: z.coerce.number().nullable(),
    amountCZK: z.coerce.number().nullable(),
    carrierCountryCode: z.string().nullable(),
    vatRate: z.number().nullable(),
    vatAmountCZK: z.coerce.number().nullable(),
    taxPointDate: zodMoment(),
    dueDate: zodMoment(),
    tsAdded: zodMoment(),
    tsEdited: zodMoment().nullable(),
});

export type TCommissionExpectedLiability = z.infer<typeof commissionExpectedLiabilitySchema>;
